import '../index';

import { Base64 } from 'js-base64';

/**
 * GOTO_GAME = 0
 * GOTO_PANDORA = 1
 * GOTO_MSDK = 2
 * GOTO_X5 = 4
 *
 */
export enum DeepLinkType {
  GOTO_GAME = 0,
  GOTO_PANDORA = 1,
  GOTO_MSDK = 2,
  GOTO_X5 = 4,
}

// 初始化下载链接
export const downloadUrls = {
  android: 'https://www.honorofkings.com/download/HonorOfKings_App_Android_9.3.1.1_4101.apk',
  ios: 'https://apps.apple.com/app/id1619254071',
};

// 获取项目名称
export const eventCategory = location.pathname.match(/(?:act|cp)\/([^/]+)/)?.[1] ?? location.host;

/**
 * UA参数
 */
export const UserAgent = navigator.userAgent;

/** 是否是本地开发环境 */
export function isLocalEnv(): boolean {
  // return location.hostname === 'localhost' || location.hostname === '127.0.0.1';
  return /^localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(location.hostname);
}

/** 是否是测试环境 */
export function isTestEnv(): boolean {
  return location.hostname === 'events-test-1310788819.cos-website.ap-singapore.myqcloud.com';
}

/** 是否是正式环境 */
export function isProductEnv(): boolean {
  return location.hostname === 'events.iegcom.com';
}

/** PHP explode 的 JavaScript 实现：使用一个字符串分割另一个字符串 */
export function explode(sep: string, str: string, limit?: number): string[] {
  if (!str) return [];
  const arr = str.split(sep);
  if (!limit || limit <= 0 || arr.length <= limit) return arr;
  const tmp = arr.splice(0, limit - 1);
  tmp.push(arr.join(sep));
  return tmp;
}

/** 获取指定的链接参数 */
export function getQueryParam(name: string): string | undefined {
  const reg = new RegExp(`\\b${name}=([^&#?]*)`);
  const matched = location.search?.match(reg);
  // console.log(matched);
  if (!matched) return undefined;
  return matched[1];
}

/** 获取多个查询参数 */
export function getQueryParams(...names: string[]) {
  const out: { [n: string]: string | undefined } = {};
  for (const n of names) {
    out[n] = getQueryParam(n);
  }
  return out;
}

/** 获取全部的链接参数 */
export function getAllQueryParams(url?: string): { [k: string]: string } {
  const out: { [k: string]: string } = {};
  if (!url) url = location.search;
  if (!url) return out;
  const [, queryString] = explode('?', url, 2);
  if (!queryString) return out;
  const arr = queryString.split('&');
  for (const s of arr) {
    let [k, v] = explode('=', s, 2);
    if (v == null) continue;
    k = decodeURIComponent(k);
    v = decodeURIComponent(v);
    out[k] = v;
  }
  return out;
}

/** 构造链接参数 */
export function buildQueryParams(params: { [k: string]: string | number | boolean | null | undefined }): string {
  const arr: string[] = [];
  for (const [k, v] of Object.entries(params)) {
    if (v == null) continue;
    arr.push(k + '=' + encodeURIComponent(v));
  }
  return arr.join('&');
}

/**
 * json解码的预处理
 * @param jsonEncodedString
 */
export function json_decode(jsonEncodedString: string): any {
  try {
    // 使用 JSON.parse 进行 JSON 解码
    return JSON.parse(jsonEncodedString);
  } catch (error) {
    if (error instanceof SyntaxError) {
      console.error('JSON 解码失败:', error.message);
      return undefined; // 或者您可以选择抛出错误
    }
    throw error; // 如果不是 SyntaxError，则重新抛出异常
  }
}

/**
 * 添加前置参数
 * @param num
 * @param prefix
 */
export function prefixNumber(num: number, prefix = '0'): string {
  if (num > 9) return String(num);
  return prefix + num;
}

/**
 * 格式化时间
 * @param format
 * @param date
 */
export function formatDate(format: string, date?: Date | number): string {
  if (!date) date = new Date();
  else if (!(date instanceof Date)) date = new Date(date);
  const arr: (string | number)[] = [];
  for (let i = 0; i < format.length; i++) {
    const s = format[i];
    if (s === 'Y') arr.push(date.getFullYear());
    else if (s === 'm') arr.push(prefixNumber(date.getMonth() + 1));
    else if (s === 'd') arr.push(prefixNumber(date.getDate()));
    else if (s === 'H') arr.push(prefixNumber(date.getHours()));
    else if (s === 'i') arr.push(prefixNumber(date.getMinutes()));
    else if (s === 's') arr.push(prefixNumber(date.getSeconds()));
    else arr.push(s);
  }
  return arr.join('');
}

/**
 * 生成当前Url
 * 会获取之前的请求
 * @param prefix
 * @param data 需要添加的参数 会替换掉之前的重名参数
 */
export function getCurrentUrl(prefix: string = '', data: { [key: string]: any } = {}): string {
  const queryParams = getAllQueryParams();
  Object.assign(queryParams, data);
  if (!prefix) prefix = `https://${location.host}${location.pathname}`;
  return prefix + '?' + buildQueryParams(queryParams);
}

/** 传入的值是否全为 null 或 undefined 或 空字符串 */
export function isEmpty(...vals: any): boolean {
  let ok = vals.length < 1; // 不传参为 true，其它情况初始化为 false
  for (const v of vals) {
    ok = v == null || v === '';
    if (!ok) break;
  }
  console.debug('[Act][isEmpty]', ok, vals);
  return ok;
}

/**
 * 检查对象中是否有对应的属性
 * @param obj
 * @param names
 */
export function requireParams(obj: any, ...names: any[]): boolean {
  if (!obj) return false;
  let ok = true;
  for (const n of names) {
    if (obj[n] == null || obj[n] === '') {
      ok = false;
      console.warn(`[Act] requireParams: ${n} 为空`, obj);
      break;
    }
  }
  return ok;
}

/**
 * 判断一个对象是否为空对象
 * @param obj
 */
export function isNonEmptyObject(obj: any): boolean {
  return obj && typeof obj === 'object' && Object.keys(obj).length > 0;
}

/**
 * 获取潘多拉传过来的数据解析
 * @param shareKey
 * @param defaultData
 */
export function getPandoraData<T extends { [key: string]: string }>(shareKey: string, defaultData: T): T {
  let tempData = getQueryParam(shareKey);
  if (!tempData) {
    return defaultData;
  }
  tempData = decodeURIComponent(tempData);
  tempData = Base64.decode(tempData);
  let pandoraData = json_decode(tempData) as T;
  if (!pandoraData || !isNonEmptyObject(pandoraData)) {
    pandoraData = defaultData;
  }

  // 第二步：遍历对象，对每个值进行 URL 解码
  const decodedObject = Object.keys(pandoraData).reduce((acc, key) => {
    const value = pandoraData[key] as string;
    try {
      // @ts-ignore
      acc[key] = decodeURIComponent(value);
    } catch (error) {
      if (error instanceof URIError) {
        console.error(`URL 解码失败（键: ${key}）:`, error.message);
        // @ts-ignore
        acc[key] = value;
      } else {
        throw error; // 如果不是 URIError，则重新抛出异常
      }
    }
    return acc;
  }, {} as Partial<T>); // 使用 Partial<T> 来初始化累加器对象
  const result = decodedObject as T;
  return result;
}

/**
 * 跳转 DeepLink 链接
 * @param type 拉起游戏的行为：0 只拉起游戏、1 拉起到潘多拉、2 MSDK、3 X5 浏览器
 * @param data Deeplink 链接参数：只是拉起游戏不需要传值或传空，拉起潘多拉传递一个 object 对象，拉起 MSDK 或 X5 浏览器传递一个 URL 链接
 * @param success 拉起成功时需要执行的回调函数
 * @param failed 拉起失败时需要跳转的失败页面，或者需要执行的回调函数
 */
export const gotoGame = onceCall(
  (
    type: DeepLinkType,
    data: undefined | null | string | { [key: string]: any },
    success: undefined | null | (() => any),
    failed: undefined | null | string | (() => any) = undefined,
  ) => {
    let url = '';
    if (type === DeepLinkType.GOTO_GAME) {
      console.debug('[Act][DeepLink]', '拉起游戏');
      url = 'pbpsdkhok://?gamedata=JUNMFORM_Pandora';
    } else if (type === DeepLinkType.GOTO_PANDORA) {
      const str = typeof data !== 'string' ? JSON.stringify(data) : data;
      console.debug('[Act][DeepLink]', `拉起游戏跳转到潘多拉 json = ${str}`);
      url = 'pbpsdkhok://?gamedata=JUNMFORM_Pandora_' + Base64.encode(str);
    } else if (type === DeepLinkType.GOTO_MSDK) {
      console.debug('[Act][DeepLink]', `拉起游戏 MSDK 页面链接：${data}`);
      url = 'pbpsdkhok://?gamedata=JUMPMSDK_' + encodeURIComponent(data as string);
    } else if (type === DeepLinkType.GOTO_X5) {
      console.debug('[Act][DeepLink]', `拉起游戏 X5 页面链接：${data}`);
      url = 'pbpsdkhok://?gamedata=JUMPX5_' + encodeURIComponent(data as string);
    } else {
      throw 'Invalid DeepLink Type: ' + type;
    }

    setTimeout(() => {
      console.info('[Act][DeepLink]', `拉起游戏 DeepLink = ${url}`);
      location.href = url;
    }, 10);

    let leftCount: any = 3;
    let timer = setInterval(() => {
      leftCount! -= 1;
      if (leftCount! > 0) return;
      leftCount = null;
      clearInterval(timer);
      timer = undefined as any;

      if (document.hidden || document.visibilityState === 'hidden') {
        console.info('[Act][DeepLink]', '已成功拉起游戏~');
        gtag('event', 'deeplink_success', { event_category: eventCategory, event_label: 'goto game' });
        success?.();
      } else if (failed) {
        console.info('[Act][DeepLink]', '无法在规定时间内拉起游戏~');
        gtag('event', 'deeplink_failed', { event_category: eventCategory, event_label: 'goto game' });
        if (typeof failed === 'function') failed();
        else location.href = failed as string;
      }
    }, 1000);
    // }, 500);
  },
);

/**
 * 是否是安卓设备
 */
export function isAndroid(): boolean {
  return /Android/i.test(UserAgent);
}

/** 判断当前 UA 是否是 iOS */
export function isIOS(): boolean {
  return /\biPhone|\biPad|iPod|\bMac/i.test(UserAgent);
}

/**
 * 是否是三星设备
 */
export function isSamsung(): boolean {
  return /SAMSUNG|SGH-[I|N|T]|GT-[I|P|N]|SM-[N|P|T|Z|G]|SHV-E|SCH-[I|J|R|S]|SPH-L/i.test(UserAgent);
}

/**
 * 是否在 INS APP中
 */
export function isInstagram(): boolean {
  return /\bInstagram/.test(UserAgent);
}

/**
 * 是否在facebook APP中
 */
export function isFacebook(): boolean {
  return /\bFBAN|\bFBAV|\bFBIOS/.test(UserAgent);
}

/**
 * 是否在WeChat APP中
 */
export function isWeChat() {
  return /MicroMessenger/gi.test(UserAgent);
}

/**
 * 是否在QQ APP中
 */
export function isQQ() {
  const REGEXP_IOS_QQ = new RegExp('(iPad|iPhone|iPod).*? (IPad)?QQ\\/([\\d\\.]+)');
  const REGEXP_ANDROID_QQ = new RegExp('\\bV1_AND_SQI?_([\\d\\.]+)(.*? QQ\\/([\\d\\.]+))?', 'ig');
  //判断是否是 IOSQQ 或者 AndroidQQ打开
  const isIphoneOs_QQ = REGEXP_IOS_QQ.test(UserAgent);
  const isAndroid_QQ = REGEXP_ANDROID_QQ.test(UserAgent);
  return isIphoneOs_QQ || isAndroid_QQ;
}

/** 返回一个在指定时间 interval （秒，默认3秒）内只能调用一次 fn 的函数 */
export function onceCall(fn: (...args: any[]) => any, interval: number = 3) {
  let timer: any = undefined;
  return (...args: any[]) => {
    if (timer) {
      console.debug(`[Act][onceCall] ${interval} 秒只能调用一次`);
      return;
    }
    timer = setTimeout(() => {
      clearTimeout(timer);
      timer = undefined;
    }, interval * 1000);
    return fn(...args);
  };
}

/** 启动一个定时器，每隔一定时间 tick 执行一次回调函数，如果回调函数返回 false 则表示提前终止定时器，timeout 参数表示超时 */
export function startTimer(onTick: (isTimeout: boolean) => any, timeout: number = 5000, tick: number = 100) {
  const target = Math.ceil(timeout / tick);
  let i = 0;
  const cb = () => {
    i += 1;
    const isTimeout = i > target; // 是否超时
    if (onTick?.(isTimeout) === false) return; // 显示返回 false 表示提前终止定时器
    if (!isTimeout) setTimeout(cb, tick); // 还未等待超时，等待下一次 tick 回调
  };
  setTimeout(cb, tick);
}

/**
 * 进行分享
 * @param url
 * @param title
 * @param text
 */
export function shareFunction(url: string, title: string, text: string) {
  if (!navigator.share) {
    console.error('[Act] 当前浏览器不支持 navigator.share 方法');
    return;
  }
  console.log('分享链接：', url);
  navigator
    .share({ title, text, url })
    .then(() => {
      console.info('[Act] 分享成功');
    })
    .catch((err) => {
      console.error('[Act] 分享失败：', err);
    });
}

type jumpDeepLinkFunction = (key?: any) => any;

/**
 * 跳转DeepLink
 * @param {{type:DeepLinkType,pandoraData:undefined | null | string | { [key: string]: any }}} options
 * @param successFunction 跳转成功回调
 * @param failFunction    跳转失败回调
 * @param errorFunction   无法进行跳转的回调
 */
export function jumpDeepLink(
  options: {
    type: DeepLinkType;
    pandoraData: undefined | null | string | { [key: string]: any };
  },
  successFunction: jumpDeepLinkFunction | null = null,
  failFunction: jumpDeepLinkFunction | null = null,
  errorFunction: jumpDeepLinkFunction | null = null,
) {
  // iOS 平台下 Facebook 和 Instagram 下无法拉起客户端，需要弹窗提示用户复制链接在默认浏览器打开
  if (isIOS() && (isFacebook() || isInstagram())) {
    console.log('[Act] Deeplink 不生效，请复制页面链接在默认浏览器打开');
    // document.querySelector('.window-box p')!.innerHTML = getCurrentUrl();
    // app.show_window = true;
    if (typeof errorFunction === 'function') {
      errorFunction();
    }
    return;
  }

  // 100 毫秒后拉起 Deeplink
  setTimeout(() => {
    console.log('deepLink pandoraData', options.pandoraData);
    gotoGame(
      DeepLinkType.GOTO_PANDORA,
      options.pandoraData,
      () => {
        console.log('跳转游戏成功');
        if (typeof successFunction === 'function') {
          successFunction();
        }
      },
      () => {
        // 没能在 3 秒内拉起客户端，则直接跳转到应用商店下载页面
        console.info('拉起游戏客户端失败了，或者等待超时了~');
        if (typeof failFunction === 'function') {
          failFunction();
        }
      },
    );
  }, 100);
}

/** 注册 Deeplink 按钮，点击按钮时拉起游戏并跳转到潘多拉 */
export function registerDeeplinkButton(selectors: string, data: any, onSuccess?: () => any, onFailed?: (url: string) => any, preCheckFunction?: () => any) {
  const doms = document.querySelectorAll(selectors);
  if (!doms.length) return;

  // 拉起游戏客户端成功后的回调函数
  const cbSuccess = () => {
    // 已成功拉起游戏客户端
    console.info('[Act] 成功拉起游戏客户端了~');
    onSuccess?.();
  };
  // 拉起游戏客户端失败的回调函数
  const cbFailed = () => {
    // 没能在 3 秒内拉起客户端，则直接跳转到应用商店下载页面
    console.warn('[Act] 无法拉起游戏客户端或者等待超时~');
    let url = '';
    // ios 直接跳转到应用上带你
    if (isIOS()) url = downloadUrls.ios;
    // Android 统一使用官网包下载
    else url = downloadUrls.android;

    const ret = onFailed?.(url); // 返回 false 表示不跳转，返回字符串表示跳转到指定链接
    // eslint-disable-next-line prettier/prettier
    if (ret === false) return; // 返回 false 表示不跳转
    else if (ret && typeof ret === 'string') url = ret; // 返回字符串表示跳转到指定链接

    gtag('event', 'deeplink_failed_to_download', { event_category: eventCategory, event_label: isIOS() ? 'ios' : 'android' });
    console.warn('[Act] 似乎未能打开游戏，前往下载：', url);
    location.href = url;
  };

  for (const dom of Array.from(doms)) {
    dom.addEventListener('click', () => {
      // 如果前置检查方法返回false 则不执行方法
      if (typeof preCheckFunction === 'function') {
        let check = preCheckFunction();
        if (check === false) return;
      }
      gtag('event', 'deeplink_click', { event_category: eventCategory, event_label: 'deeplink_click' });
      if (isIOS() && (isFacebook() || isInstagram())) {
        // ios fb/ins 不支持 Deeplink，直接触发失败回调
        console.warn('[Act] iOS fb/ins Deeplink 不成效~');
        gtag('event', 'deeplink_failed', { event_category: eventCategory, event_label: 'ios fb/ins' });
        cbFailed();
      } else {
        console.info('[Act][gotoPandora] 正在尝试拉起潘多拉……');
        gotoGame(DeepLinkType.GOTO_PANDORA, data, cbSuccess, cbFailed);
      }
    });
  }
}

let currMiloActId: any = undefined;
/** 发送 Milo 请求 */
export async function miloEmit(
  actId: string,
  flowId: string,
  sData?: Milo.EmitParams['sData'],
  onSuccess?: (data: any, ret: any) => any,
  onFailed?: Milo.EmitParams['fail'],
  loading: boolean = false,
): Promise<any | void> {
  if (!window.Milo) {
    console.error(
      '[initMilo] 还未加载 Milo 库，请求在 HTML 页面引入以下代码\n<script src="https://events.honorofkings.com/act/milo-next/milo.min.js"></script>\n<script src="https://events.honorofkings.com/act/milo-next/jquery-1.11.3.min.js"></script>',
    );
    return;
  }
  if (currMiloActId != actId) {
    let idePrefix = 'https://webide-game.iegcom.com/ide';
    if (/^localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(location.hostname)) idePrefix = '/ideTest';
    else if (location.host.toLowerCase() !== 'events.honorofkings.com') idePrefix = 'https://webide-game.iegcom.com/ideTest';
    const commonConfig = {
      needPromiseCallback: false,
      activityApi: `${idePrefix}/page/${actId}`,
      ideApi: `${idePrefix}/`,
    };
    console.log('commonConfig', commonConfig);
    Milo.setCommonConfig(commonConfig);
    currMiloActId = actId;
  }
  return new Promise((resolve) => {
    Milo.emit({
      actId,
      token: flowId,
      loading,
      sData,
      success(ret) {
        const iRet = ret.details?.jData?.iRet ?? ret.details?.iRet ?? ret.iRet;
        const sMsg = ret.details?.jData?.sMsg ?? ret.details?.sMsg ?? ret.sMsg;
        if (iRet != 0) {
          resolve(void 0);
          console.error('[Milo][emit] 请求失败：', { iRet, sMsg }, ret);
          return;
        }
        const data = ret.details ?? ret.data ?? ret;
        console.debug('[Milo][emit] 请求成功：', { iRet, sMsg, data }, ret);
        onSuccess?.(data, ret);
        resolve(data);
      },
      fail(err) {
        console.error('[Milo][emit] 请求失败：', err);
        onFailed?.(err);
        resolve(void 0);
      },
    });
  });
}

/** 拉取活动配置信息 */
export async function getActivityConfig(
  actName?: string,
  extParams?: { [k: string]: any },
  onSuccess?: (data: any) => any,
  onFailed?: (err: any, ...rest: any[]) => any,
) {
  if (!actName) actName = location.pathname.match(/(?:act|cp)\/([^/]+)/)?.[1];
  miloEmit(
    '3000644_X3IFJY', // 公用请求节点，拉取活动配置信息
    'Ku69kx',
    { ...(extParams || {}), act: actName }, // act 参数指定需要拉取的活动配置
    (ret) => {
      const data = ret.jData?.jData;
      if (!data) {
        console.warn('[Act] 没有拉取到配置信息:', ret);
        onFailed?.('没有拉取到配置信息', data); // 没有获取到活动配置信息
        return;
      }
      console.info('[Act] 拉取到活动配置信息:', data);
      if (data.download) {
        console.info('[Act] 拉取到下载配置:', data.download);
        for (const [k, v] of Object.entries(data.download)) downloadUrls[k] = v as string;
        console.info('[Act] 更新下载下载链接配置:', downloadUrls);
      }

      if (data.config) {
        if (data.config.android) {
          downloadUrls.android = data.config.android;
          console.info('[Act] 更新下载下载链接配置:', downloadUrls);
        }
      }

      onSuccess?.(data);
    },
    onFailed, // 拉取活动配置信息失败: 直接初始化页面
  );
}
